import { CustomerLead } from '../../../core/domain/customerLead.model'
import AgentService from '../../../core/services/agent.service'
import CustomerService from '../../../core/services/customer.service'
import { LifecyclePresenter } from '../../_components/ConnectComponent'
import { AdobeEventManager } from '../../_utils/adobeAnalytics'
import { dataLayer } from '../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { redirectionProvider } from '../ContractRedirection.provider'
import {
  PolicyholderDataInfoValues,
  PolicyholderDataSection,
  View,
} from './PolicyholderData.view'

export class PolicyholderDataPresenter implements LifecyclePresenter<View> {
  private view!: PolicyholderDataSection
  private stepPageName: string = 'policyholder'
  private customer: CustomerLead

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    dataLayer.page.category.applicationStep = 'step9-policyholder'
    AdobeEventManager.track('calc_step')

    await this.getOfferDocument()

    const { t } = this.view.props
    this.view.setInitialValues({
      ...this.customer,
      acceptedPrivacyPolicy: this.customer.acceptedPrivacyPolicy,
      country:
        this.customer.country === 'Liechtenstein'
          ? 'Liechtenstein'
          : 'switzerland',
    })
  }

  getOfferDocument = async () => {
    try {
      this.customer = await CustomerService.getCustomer()
    } catch (error) {
      console.log(error)
    }
  }

  onContinue = async (formValues: PolicyholderDataInfoValues) => {
    const customer = this.setFormValues(formValues)

    CustomerService.saveCustomer(customer).then(() => this.goToNextStep())
  }

  setFormValues = (formValues: PolicyholderDataInfoValues) => {
    return Object.assign(this.customer, {
      ...formValues,
      acceptedPrivacyPolicy: AgentService.isAgentOrBroker()
        ? true
        : formValues.acceptedPrivacyPolicy,
    })
  }

  goToNextStep = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToFollowingStep(this.stepPageName),
    )
  }

  onBackClick = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToPreviousStep(this.stepPageName),
    )
  }
}
